import { env } from "@/config/envvars";
import { createContext, useState, useEffect } from "react";

export const MetadataContext = createContext<
  ((metadata: { title: string; description: string }) => void) | null
>(null);

export default function MetadataProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const defaultTitle = env.APP_NAME;
  const defaultDescription = "Mohtawa Creative OS";

  const [metadata, setMetadata] = useState({
    title: defaultTitle,
    description: defaultDescription,
  });

  useEffect(() => {
    document.title = metadata.title || defaultTitle;

    let meta = document.querySelector('meta[name="description"]');

    if (!meta) {
      meta = document.createElement("meta");
      (meta as HTMLMetaElement).name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", metadata.description || defaultDescription);
  }, [metadata, defaultTitle, defaultDescription]);

  return (
    <MetadataContext.Provider value={setMetadata}>
      {children}
    </MetadataContext.Provider>
  );
}
